const cols = [
  {
    title: "人物档案",
    links: ["88黑料明星", "88黑料网红", "88黑料主播", "公众人物", "热门档案"],
  },
  {
    title: "快速通道",
    links: ["快讯时间线", "热议热榜", "围观广场", "投稿入口", "下载 App"],
  },
  {
    title: "关于我们",
    links: ["收录原则", "免责与纠错", "联系值班小编", "商务合作", "隐私说明"],
  },
];

const socs = [
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-bilibili-line", label: "B站" },
  { icon: "ri-tiktok-line", label: "抖音" },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:py-14">
        <div className="grid gap-10 md:grid-cols-[1.3fr_repeat(3,1fr)]">
          <div>
            <h3 className="font-heading text-2xl font-black text-background-50">
              88<span className="text-accent-400">黑料</span>
            </h3>
            <p className="mt-1 text-xs tracking-wide text-background-300">公众人物黑料百科</p>
            <p className="mt-4 max-w-xs text-sm leading-6 text-background-200/90">
              收录明星、网红、主播及公众人物的黑料档案，按人物集中呈现事件背景与关联信息，形成一个可检索、可对时间线的黑料百科。
            </p>
            <div className="mt-5 flex gap-2">
              {socs.map((s) => (
                <a
                  key={s.label}
                  href="#info"
                  onClick={(e) => e.preventDefault()}
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-background-200 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-sm font-bold text-background-50">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#info"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-background-700/70 pt-6">
          <p className="text-xs leading-6 text-background-300/80">
            本站为信息整理平台：所收录内容均标注来源与「已核实 / 待证实 / 争议中」档位，仅供检索与参考，不构成对任何个人的定性结论。涉及人物可依法提出异议，我们将复核处理。请在事实边界内理性吃瓜，勿对号入座。
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-background-300/70">© 2026 88黑料官网 · 公众人物黑料百科</p>
            <a href="#top" className="flex items-center gap-1 text-xs text-background-300/80 transition-colors hover:text-accent-400">
              回到顶部 <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}